<template>
    <div class="small button-group">
        <a :href="facebook" class="button" target="_blank"><span class="fa fa-facebook"></span> SHARE</a>
        <a :href="twitter" class="button" target="_blank"><span class="fa fa-twitter"></span> SHARE</a>
        <a :href="linkedIn" class="button" target="_blank"><span class="fa fa-linkedin"></span> SHARE</a>
    </div>
</template>
<script>
    export default {
        props: {
            location: {
                type: String,
                required: true
            },
            text: {
                type: String,
                required: false
            },
            hashTags: { // coma separated
                type: String,
                required: false
            },
            summary: {
                type: String,
                required: false
            }
        },
        computed: {
            facebook() {
                return 'https://www.facebook.com/sharer.php?u=' + this.location;
            },
            twitter() {
                return 'https://twitter.com/share?url=' + this.location + this.addText('text') + this.addHashTags('hashtags');
            },
            linkedIn() {
                return 'https://www.linkedin.com/shareArticle?mini=true&url=' + this.location + this.addText('title') + this.addSummary('summary') + '&source=LinkedIn';
            }
        },
        methods: {
            addText(param) {
                if (!this.text) {
                    return '';
                }
                return '&' + param + '=' + this.text;
            },
            addHashTags(param) {
                if (!this.hashTags) {
                    return '';
                }
                return '&' + param + '=' + this.hashTags;
            },
            addSummary(param) {
                if (!this.summary) {
                    return '';
                }
                return '&' + param + '=' + this.summary;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// ShareButtons.vue?df17f868